<div class="mat-typography full-height flex-row">
    <div>
        <app-sidenav></app-sidenav>
    </div>
    <div
        class="main-content d-flex flex-direction-column padding-for-cq-banner"
        [ngClass]="{ 'padding-for-cq-banner': cqService.showBanner, 'padding-without-cq-banner': !cqService.showBanner }"
    >
        <app-banner></app-banner>
        <router-outlet></router-outlet>
    </div>
</div>
